import { Tabs } from "antd";
import { RequirementsTutorsListingPanelProps } from "../types";
import { StudentRequirementsTutorsShortlistedTable } from "./Shortlisted";
import { StudentRequirementsTutorsProcessTable } from "./Process";
import { useState } from "react";


export function RequirementsTutorsListingPanel(
  props: RequirementsTutorsListingPanelProps
) {
	const { studentDetails } = props;
  const [activeKey, setActiveKey] = useState("1");

  return (
    <Tabs
      activeKey={activeKey}
      onChange={setActiveKey}
      items={[
        {
          key: "1",
          label: "Process",
          children: (
            <StudentRequirementsTutorsProcessTable
              key={activeKey}
              studentDetails={studentDetails}
              setStudentDealStatus={props.setStudentDealStatus}
            />
          ),
        },
        {
          key: "2",
          label: "Shortlist",
          children: (
            <StudentRequirementsTutorsShortlistedTable
              key={activeKey}
              studentDetails={studentDetails}
              setStudentDealStatus={props.setStudentDealStatus}
            />
          ),
        },
      ]}
    />
  );
}
